import React from 'react';
import { Box, Grid, Paper, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useChat } from '../../hooks/useChat';
import ChannelList from './ChannelList';
import ChatWindow from './ChatWindow';
import './ChatStyles.css';

const ChatLayout = ({ searchQuery }) => {
  const chat = useChat();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // On mobile, if we have an active channel, we show the chat window, otherwise the list.
  const showList = !isMobile || !chat.activeChannel;
  const showChat = !isMobile || (isMobile && chat.activeChannel);

  return (
    <Box
      className="chat-layout"
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        bgcolor: '#fff',
        overflow: 'hidden',
        flex: 1
      }}
    >
      {showList && (
        <Box
          sx={{
            width: isMobile ? '100%' : 300,
            borderRight: isMobile ? 'none' : '1px solid #edebe9',
            bgcolor: '#f5f5f5',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <ChannelList {...chat} searchQuery={searchQuery} />
        </Box>
      )}
      
      {showChat && (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, width: isMobile ? '100%' : 'auto' }}>
          <ChatWindow {...chat} isMobile={isMobile} />
        </Box>
      )}
    </Box>
  );
};

export default ChatLayout;